let Lexica = {
	legal: {
		lexicon: 'legal',
		case: 'Case',
		legalIssues: 'Issues',
		issue: 'Issue',
		contributors: 'Contributors',
		contributor: 'Contributor',
		factDateish: 'Key Date',
		sources: 'Sources',
		tags: 'Tags',
		title: 'Title',
		content: 'Content',
		creationDate: 'Creation Date',
		memo: 'Memo',
		firm: 'Firm'
	},
	media: {
		lexicon: 'media',
		case: 'Project',
		legalIssues: 'Topics',
		issue: 'Topic',
		contributors: 'Collaborators',
		contributor: 'Collaborator',
		factDateish: 'Key Date',
		sources: 'Sources',
		tags: 'Tags',
		title: 'Title',
		content: 'Content',
		creationDate: 'Creation Date',
		memo: 'Doc',
		firm: 'Account'
	}
};
export default angular.module('contants.lexica', [])
	.constant('Lexica', Lexica)
	.name;



// WEBPACK FOOTER //
// ./project/constants/lexica.js